import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

export async function updatePhysicalStructure(id) {
  const url = SURVEY_ENDPOINTS.PHYSICAL_STRUCTURE.replace(':id', id)
  const response = await apiClient('generic-survey').post(url)
  if (response.data?.success === false) {
    throw new Error(response.data?.message || 'Failed to update the physical structure')
  }
  return response.data?.data ?? null
}
